import React from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Products from './components/Products/Products';
import About from './components/About/About';
import Gallery from './components/Gallery/Gallery';
import Reviews from './components/Reviews/Reviews';
import Contact from './components/Contact/Contact';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Products />
      <About />
      <Gallery />
      <Reviews />
      <Contact />
    </div>
  );
}

export default App;